import { publicProfileActionTypes } from './Constants';

export function getPublicProfileInfoRequest(username) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_REQUEST,
		payload: {
			username,
		},
	};
}

export function getPublicProfileInfoSuccess(userInfo) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_SUCCESS,
		payload: {
			userInfo,
		},
	};
}

export function getPublicProfileInfoError() {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_ERROR,
	};
}

export function getPublicListsRequest(username) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_LISTS_REQUEST,
		payload: {
			username,
		},
	};
}

export function getPublicListsSuccess(lists) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_LISTS_SUCCESS,
		payload: {
			lists,
		},
	};
}

export function getPublicListsError() {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_LISTS_ERROR,
	};
}

export function getPublicFoldersRequest(username) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_FOLDERS_REQUEST,
		payload: {
			username,
		},
	};
}

export function getPublicFoldersSuccess(folders) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_FOLDERS_SUCCESS,
		payload: {
			folders,
		},
	};
}

export function getPublicFoldersError() {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_FOLDERS_ERROR,
	};
}

export function checkUserNameRequest(data) {
	return {
		type: publicProfileActionTypes.CHECK_USER_NAME_REQUEST,
		payload: {
			data,
		},
	};
}

export function checkUserNameSuccess(data) {
	return {
		type: publicProfileActionTypes.CHECK_USER_NAME_SUCCESS,
		payload: {
			data,
		},
	};
}

export function checkUserNameError(data) {
	return {
		type: publicProfileActionTypes.CHECK_USER_NAME_ERROR,
		payload: {
			data,
		},
	};
}

export function getPublicQuestionsRequest(username, data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_QUESTIONS_REQUEST,
		payload: {
			username,
			data,
		},
	};
}

export function getPublicQuestionsSuccess(data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_QUESTIONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getPublicQuestionsError(data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_QUESTIONS_ERROR,
		payload: {
			data,
		},
	};
}

export function getPublicAnswersRequest(username, data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_ANSWERS_REQUEST,
		payload: {
			username,
			data,
		},
	};
}

export function getPublicAnswersSuccess(data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_ANSWERS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getPublicAnswersError(data) {
	return {
		type: publicProfileActionTypes.GET_PUBLIC_ANSWERS_ERROR,
		payload: {
			data,
		},
	};
}

export function getAchievements(username) {
	return {
		type: publicProfileActionTypes.GET_ACHIEVEMENTS_REQUEST,
		payload: { username },
	};
}

export function getAchievementsSuccess(data) {
	return {
		type: publicProfileActionTypes.GET_ACHIEVEMENTS_SUCCESS,
		payload: { data },
	};
}

export function getAchievementsError() {
	return {
		type: publicProfileActionTypes.GET_ACHIEVEMENTS_ERROR,
	};
}

export function setLoading() {
	return {
		type: publicProfileActionTypes.SET_LOADING,
		payload: {},
	};
}

export function clearPublicProfileInfo() {
	return {
		type: publicProfileActionTypes.CLEAR_PUBLIC_PROFILE_INFO,
	};
}
export function clearPublicLists() {
	return {
		type: publicProfileActionTypes.CLEAR_PUBLIC_LISTS,
	};
}
export function clearPublicFolders() {
	return {
		type: publicProfileActionTypes.CLEAR_PUBLIC_FOLDERS,
	};
}
